import React from 'react';
import { Box } from '@mui/material';

export interface ApplicationStatusBadgeProps {
  count: number;
  className?: string;
  style?: React.CSSProperties;
}

export const ApplicationStatusBadge: React.FC<ApplicationStatusBadgeProps> = ({
  count,
  className,
  style,
}) => {
  return (
    <Box
      className={className}
      style={style}
      sx={{
        backgroundColor: '#e5e7eb',
        color: '#374151',
        fontWeight: 400,
        fontSize: '14px',
        minWidth: '24px',
        height: '24px',
        borderRadius: '9999px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 8px',
      }}
    >
      {count}
    </Box>
  );
};
